import { render, staticRenderFns } from "./pos-contact-summary.vue?vue&type=template&id=6bee3d75&scoped=true&"
import script from "./pos-contact-summary.vue?vue&type=script&lang=ts&"
export * from "./pos-contact-summary.vue?vue&type=script&lang=ts&"
import style0 from "./pos-contact-summary.vue?vue&type=style&index=0&id=6bee3d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee3d75",
  null
  
)

export default component.exports